/* Add to Cart — Card-based variant selector, subscription toggle, selling plans */
(function() {
  'use strict';

  var root = document.querySelector('[data-atc-root]');
  if (!root) return;

  var form = root.querySelector('[data-add-to-cart-form]');
  if (!form) return;

  /* ── DOM refs ─────────────────────────────────── */
  var variantInput    = form.querySelector('[data-variant-input]');
  var sellingPlanInput = form.querySelector('[data-selling-plan-input]');
  var submitBtn       = form.querySelector('.add-to-cart-btn');
  var priceDisplay    = root.querySelector('[data-price-display]');
  var compareDisplay  = root.querySelector('[data-compare-display]');

  var buyOnceCard     = root.querySelector('[data-buy-once]');
  var subscribeCard   = root.querySelector('[data-subscribe-card]');
  var variantCards    = root.querySelectorAll('.variant-card');
  var planPills       = root.querySelectorAll('.plan-pill');
  var subPriceEl      = root.querySelector('[data-sub-price]');

  /* ── JSON data ────────────────────────────────── */
  var subVariant = null;
  var subVariantEl = document.querySelector('[data-sub-variant]');
  if (subVariantEl) {
    try { subVariant = JSON.parse(subVariantEl.textContent); } catch(e) {}
  }

  /* ── State ────────────────────────────────────── */
  var mode = 'onetime'; // 'onetime' | 'subscribe'
  var selectedVariantId = '';
  var selectedPlanId = '';

  // Default variant: whichever card has is-selected (3-pack)
  var defaultCard = root.querySelector('.variant-card.is-selected');
  if (defaultCard) {
    selectedVariantId = defaultCard.dataset.variantId;
  } else if (variantCards.length > 0) {
    selectedVariantId = variantCards[0].dataset.variantId;
  }

  // Default plan: whichever pill has is-active
  var defaultPill = root.querySelector('.plan-pill.is-active');
  if (defaultPill) {
    selectedPlanId = defaultPill.dataset.planId;
  }

  /* ── Helpers ──────────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Mode toggle ──────────────────────────────── */
  function updateMode(newMode) {
    mode = newMode;

    // Toggle active states — CSS handles show/hide of card bodies
    if (buyOnceCard) buyOnceCard.classList.toggle('is-active', mode === 'onetime');
    if (subscribeCard) subscribeCard.classList.toggle('is-active', mode === 'subscribe');

    // Update hidden form inputs
    if (mode === 'subscribe' && subVariant) {
      if (variantInput) variantInput.value = subVariant.id;
      if (sellingPlanInput) sellingPlanInput.value = selectedPlanId;
    } else {
      if (variantInput) variantInput.value = selectedVariantId;
      if (sellingPlanInput) sellingPlanInput.value = '';
    }

    updatePriceDisplay();
  }

  /* ── Variant selection (Buy Once) ─────────────── */
  function selectVariant(variantId) {
    selectedVariantId = variantId;
    if (variantInput && mode === 'onetime') {
      variantInput.value = variantId;
    }

    variantCards.forEach(function(card) {
      card.classList.toggle('is-selected', card.dataset.variantId === variantId);
    });

    updatePriceDisplay();
  }

  /* ── Plan selection (Subscribe) ───────────────── */
  function selectPlan(planId) {
    selectedPlanId = planId;
    if (sellingPlanInput && mode === 'subscribe') {
      sellingPlanInput.value = planId;
    }

    planPills.forEach(function(pill) {
      pill.classList.toggle('is-active', pill.dataset.planId === planId);
    });

    updatePriceDisplay();
  }

  /* ── Price display ────────────────────────────── */
  var discountBadge = root.querySelector('[data-discount-badge]');

  function updatePriceDisplay() {
    if (mode === 'subscribe' && subVariant) {
      var activePill = root.querySelector('.plan-pill.is-active');
      var planPrice = activePill ? parseInt(activePill.dataset.planPrice) : subVariant.price;

      if (priceDisplay) priceDisplay.textContent = formatMoney(planPrice);

      if (compareDisplay) {
        if (planPrice < subVariant.price) {
          compareDisplay.textContent = formatMoney(subVariant.price);
          compareDisplay.style.display = '';
          var pct = Math.round((subVariant.price - planPrice) / subVariant.price * 100);
          if (discountBadge) { discountBadge.textContent = pct + '% OFF'; discountBadge.style.display = ''; }
        } else {
          compareDisplay.style.display = 'none';
          if (discountBadge) discountBadge.style.display = 'none';
        }
      }

      if (subPriceEl) subPriceEl.textContent = formatMoney(planPrice);
    } else {
      var selectedCard = root.querySelector('.variant-card[data-variant-id="' + selectedVariantId + '"]');
      if (selectedCard) {
        var price = parseInt(selectedCard.dataset.price);
        var comparePrice = parseInt(selectedCard.dataset.comparePrice);

        if (priceDisplay) priceDisplay.textContent = formatMoney(price);

        if (compareDisplay) {
          if (comparePrice && comparePrice > price) {
            compareDisplay.textContent = formatMoney(comparePrice);
            compareDisplay.style.display = '';
            var pct = Math.round((comparePrice - price) / comparePrice * 100);
            if (discountBadge) { discountBadge.textContent = pct + '% OFF'; discountBadge.style.display = ''; }
          } else {
            compareDisplay.style.display = 'none';
            if (discountBadge) discountBadge.style.display = 'none';
          }
        }
      }
    }
  }

  /* ── Event listeners ──────────────────────────── */

  // Buy Once card — switch to one-time mode
  if (buyOnceCard) {
    buyOnceCard.addEventListener('click', function() {
      updateMode('onetime');
    });
  }

  // Subscribe card — switch to subscribe mode
  if (subscribeCard) {
    subscribeCard.addEventListener('click', function() {
      updateMode('subscribe');
    });
  }

  // Variant cards — select variant (stop propagation so Buy Once card click doesn't fire)
  variantCards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      e.stopPropagation();
      selectVariant(card.dataset.variantId);
    });
  });

  // Plan pills — select frequency (stop propagation so Subscribe card click doesn't fire)
  planPills.forEach(function(pill) {
    pill.addEventListener('click', function(e) {
      e.stopPropagation();
      selectPlan(pill.dataset.planId);
    });
  });

  // Form submit — AJAX add to cart
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (submitBtn.disabled) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';

    var detail = {
      variantId: variantInput.value,
      quantity: 1,
      items: [{ id: variantInput.value, quantity: 1 }]
    };
    if (mode === 'subscribe' && sellingPlanInput && sellingPlanInput.value) {
      detail.sellingPlan = sellingPlanInput.value;
      detail.items[0].selling_plan = sellingPlanInput.value;
    }

    // Check for upsell add-on
    var upsellCheckbox = root.querySelector('[data-upsell-checkbox]');
    if (upsellCheckbox && upsellCheckbox.checked) {
      detail.items.push({ id: upsellCheckbox.dataset.upsellId, quantity: 1 });
    }

    document.dispatchEvent(new CustomEvent('cart:add', { detail: detail }));

    setTimeout(function() {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Claim Offer';
    }, 1000);
  });

  // Expandable sections
  document.querySelectorAll('.expandable-section__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var section = trigger.closest('.expandable-section');
      section.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', section.classList.contains('is-open'));
    });
  });

  /* ── Initialize ───────────────────────────────── */

  // Set initial subscribe card price
  if (subPriceEl && subVariant) {
    var initPill = root.querySelector('.plan-pill.is-active');
    var initPrice = initPill ? parseInt(initPill.dataset.planPrice) : subVariant.price;
    subPriceEl.textContent = formatMoney(initPrice);
  }

  // Set initial variant input
  if (variantInput) variantInput.value = selectedVariantId;

  // Set initial price display
  updatePriceDisplay();

  // Auto-scroll to subscribe if URL hash is #subscribe
  if (window.location.hash === '#subscribe' && subscribeCard) {
    updateMode('subscribe');
    setTimeout(function() {
      subscribeCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  }

})();
